// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f3e53277","455":"e789c436","977":"1a3b1175"}[chunkId] + ".chunk.js";
};